import {
    GET_ACTIVE_PROJECT_COMPLIANCE_RULES,
    LIST_RULE_SET_RULES,
    UPDATE_RULE_SET,
    CREATE_RULE_SET,
    GET_RULE_SET,
    ASSOCIATE_RULES_WITH_SET, // Add this constant
    get_headers,
    get_project_id
} from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import axios from "axios";
import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'datatables.net';
import $ from 'jquery';

export default {
    name: 'GroupComplianceRules',
    mixins: [alert_mixin],
    data: () => ({
            new_ruleset_name: '',
            new_ruleset_description: '',
            headers: get_headers(),
            project_id: get_project_id(),
            selected_rules: [],
            compliance_rules: [],
            rule_sets: [],
            table_headers: ['Rule Set Name', 'Description', 'Rules Count', 'Status', 'Actions'],
            table_data: [],
            current_ruleset_id: null,  // To track which rule set we're assigning to
            assign_modal_visible: false,
            rules_for_assignment: [],
            assigned_rules: [], // Track which rules are assigned to current ruleset
            assign_rules_table: null ,
            editing_ruleset: {
                id: null,
                name: '',
                description: '',
                is_active: true
            }
    }),
    mounted() {
        this.fetch_compliance_rules();
        this.fetch_rule_sets();
    },
    
    methods: {
        init_data_table() {
            if (this.dataTable) {
            this.dataTable.destroy();
            }
            
            this.dataTable = $('#group_compliance_rules_table').DataTable({
            responsive: true,
            emptyTable: "No data available in table",
            language: {
                info: "", // Capitalized "Entries"
                lengthMenu: "_MENU_&nbsp;&nbsp;Entries per page" // Added non-breaking space
            }
            });
        },

        async fetch_compliance_rules() {
            this.is_loading= true;
            try {
                const response = await axios.post(
                    GET_ACTIVE_PROJECT_COMPLIANCE_RULES,
                    { project_id: this.project_id },
                    { headers: this.headers }
                );
                
                const response_data = response.data.data || response.data;
                this.compliance_rules = response_data.map(rule => ({
                    id: rule.id,
                    name: rule.name || 'Unnamed Rule',
                    description: rule.description || 'No description',
                    is_active: rule.is_active || false,
                }));
                
            } catch (error) {
                this.show_error("Error loading compliance rules"  || error.message);
            }
        },

        async fetch_rule_sets() {
            this.is_loading = true;
            try {
                const payload = { project_id: this.project_id };
                const response = await axios.post(
                    GET_RULE_SET,
                    payload,
                    { headers: this.headers }
                );
                
                this.rule_sets = response.data.data || response.data;
                this.update_table_data();
            } catch (error) {
                this.show_error("Error loading rule sets" || error.message);
            }
        },

        update_table_data() {
            this.table_data = this.rule_sets.map(rule_set => ({
                id: rule_set.id,
                'Rule Set Name': rule_set.name || 'Unnamed Rule Set',
                'Description': rule_set.description || 'No description',
                'Rules Count': rule_set.rules?.length || 0,
                'Status': rule_set.is_active ? 'Active' : 'Inactive',
            }));
        },

        async create_rule_set() {
            if (!this.new_ruleset_name) {
                this.show_error("Please enter a rule set name");
                return;
            }
            
            try {
                const rule_set_payload = {
                    name: this.new_ruleset_name,
                    description: this.new_ruleset_description,
                    project_id: this.project_id,
                    is_active: true
                };
                
                await axios.post(
                    CREATE_RULE_SET,
                    rule_set_payload,
                    { headers: this.headers }
                );

                this.show_success(`Rule set "${this.new_ruleset_name}" created successfully with ${this.selected_rules.length} rules!`);
                await this.fetch_rule_sets();                
                this.reset_form();
                
            } catch (error) {
                this.show_error("Error creating rule set" || error.message);
            }
        },

        open_edit_modal(ruleset_id) {
            const rule_set = this.rule_sets.find(rs => rs.id === ruleset_id);
            if (rule_set) {
                this.editing_ruleset = {
                    id: rule_set.id,
                    name: rule_set.name,
                    description: rule_set.description,
                    is_active: rule_set.is_active
                };
            }
        },

        async update_rule_set() {
            this.is_loading = true;
            if (!this.editing_ruleset.name) {
                this.show_error("Please enter a rule set name");
                return;
            }
            
            try {
                const payload = {
                    ruleset_id: this.editing_ruleset.id,
                    name: this.editing_ruleset.name,
                    description: this.editing_ruleset.description,
                    is_active: this.editing_ruleset.is_active,
                    project_id: this.project_id
                };

                await axios.post(
                    UPDATE_RULE_SET,
                    payload,
                    { headers: this.headers }
                );
                
                this.show_success("Rule set updated successfully!");
                await this.fetch_rule_sets();
                this.close_modal('edit_new_rule_set');
                
            } catch (error) {
                this.show_error("Error updating rule set: " + (error.response?.data?.message || error.message));
            }
        },

        get_rule_by_id(id) {
            return this.compliance_rules.find(rule => rule.id === id) || {};
        },
        
        async open_assign_modal(ruleset_id) {
            this.current_ruleset_id = ruleset_id;
            
            // Find the rule set to get its name for the modal title
            const rule_set = this.rule_sets.find(rs => rs.id === ruleset_id);
            if (rule_set) {
                this.editing_ruleset.name = rule_set.name;
            }
            
            // Fetch the assigned rules for this ruleset
            this.assigned_rules = await this.get_assigned_rules_to_set(ruleset_id);
            
            // Initialize DataTable when modal opens
            this.$nextTick(() => {
                if (!this.assign_rules_table && document.getElementById('assign_rules_table')) {
                    this.assign_rules_table = $('#assign_rules_table').DataTable({
                        responsive: true,
                        destroy: true,
                        language: {
                            info: "",
                            lengthMenu: "_MENU_ entries per page"
                        }
                    });
                }
            });
        },

        is_rule_assigned(rule_id) {
            return this.assigned_rules.includes(rule_id);
        },
        
        select_all_rules_for_assignment() {
            this.rules_for_assignment = this.compliance_rules
                .filter(rule => rule.is_active)
                .map(rule => rule.id);
        },
        
        async assign_rules_to_set() {
            if (!this.current_ruleset_id) {
                this.show_error("No rule set selected");
                return;
            }
            
            if (this.rules_for_assignment.length === 0) {
                this.show_error("Please select at least one rule");
                return;
            }
            
            try {
                await this.toggle_rule_assignment(this.current_ruleset_id);
                this.show_success("Rules assigned successfully!");
                await this.fetch_rule_sets();
            } catch (error) {
                this.show_error("Error assigning rules: " || error.message);
            }
        },

        async get_assigned_rules_to_set(ruleset_id) {
            try {
                const payload = { ruleset_id: ruleset_id }; // Use the passed ruleset_id
                const response = await axios.post(
                    LIST_RULE_SET_RULES,
                    payload,
                    { headers: this.headers }
                );

                // Extract the compliance_rule_id from each item in the response
                this.assigned_rules = response.data.data.map(item => item.compliance_rule);
                return this.assigned_rules;
            } catch (error) {
                this.show_error("Error loading assigned rules: " + (error.response?.data?.message || error.message));
                return [];
            }
        },
        
        async toggle_rule_assignment(rule_id, is_checked) {
            try {
                const payload = {
                    ruleset_id: this.current_ruleset_id,
                    compliance_rule_id: rule_id,
                    is_active: is_checked
                };
                
                await axios.post(
                    ASSOCIATE_RULES_WITH_SET,
                    payload,
                    { headers: this.headers }
                );

                // Update local state immediately
                if (is_checked) {
                    if (!this.assigned_rules.includes(rule_id)) {
                        this.assigned_rules.push(rule_id);
                    }
                } else {
                    this.assigned_rules = this.assigned_rules.filter(id => id !== rule_id);
                }
                
                this.show_success(`Rule ${is_checked ? 'assigned to' : 'unassigned from'} rule set.`);
                
            } catch (error) {
                this.show_error("Error while assigning rule: " + (error.response?.data?.message || error.message));
                // Revert the UI change if the API call fails
                const checkbox = document.getElementById(`toggle_${rule_id}`);
                if (checkbox) {
                    checkbox.checked = !is_checked;
                }
            }
        },

        // Clean up DataTable when modal closes
        cleanup_assign_rules_table() {
            if (this.assign_rules_table) {
                this.assign_rules_table.destroy();
                this.assign_rules_table = null;
            }
        },
        
        reset_form() {
            this.new_ruleset_name = '';
            this.new_ruleset_description = '';
            this.selected_rules = [];
        }
    },
    beforeDestroy() {
        this.cleanup_assign_rules_table();

        if (this.dataTable) {
        this.dataTable.destroy();
        }
    },
}
